// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2An0Y","title":"styles_title__r5YEe"};